(() => {
  if (customElements.get('customer-cashback-bar')) return;

  class CustomerCashbackBar extends HTMLElement {
    connectedCallback() {
      this.update = this.update || (() => this.render());
      window.addEventListener('customer:cashback:updated', this.update);
      document.addEventListener('visibilitychange', this.update);
      this.render();
    }

    disconnectedCallback() {
      window.removeEventListener('customer:cashback:updated', this.update);
      document.removeEventListener('visibilitychange', this.update);
      clearTimeout(this.timer);
    }

    render() {
      clearTimeout(this.timer);
      this.hidden = true;
      const state = window.customerCashback?.getState();
      let balance = state?.status === 'ready' ? state.balance : null;

      if (!balance && this.dataset.designMode === 'true' && this.dataset.showDemo === 'true') {
        balance = { amount: '12.50', currency: 'EUR', nextExpiry: Math.floor(Date.now() / 1000) + 2 * 86400 };
      }
      
      const remaining = Number(balance?.nextExpiry) * 1000 - Date.now();
      const amount = Number(balance?.amount);
      if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(remaining) || remaining <= 0) return;
      const textElement = this.querySelector('[data-cashback-bar-text]');
      if (!textElement) return;
      let formatted;
      try {
        formatted = new Intl.NumberFormat(document.documentElement.lang || 'de', {
          style: 'currency', currency: balance.currency
        }).format(amount);
      } catch { return; }
      const day = 86400000;
      const days = Math.ceil(remaining / day);
      const threshold = Number(this.dataset.daysThreshold);
      const expiring = this.dataset.showDays === 'true' && Number.isFinite(threshold) && threshold > 0 && days <= threshold;
      const warning = this.dataset.expiryText;
      const template = expiring && warning ? warning : this.dataset.text;
      if (!template?.trim()) return;
      textElement.textContent = template.replaceAll('{balance}', formatted).replaceAll('{days}', String(days));
      this.hidden = false;
      if (document.visibilityState !== 'hidden') {
        const nextDayChange = remaining - (days - 1) * day;
        this.timer = setTimeout(this.update, Math.max(1, Math.min(nextDayChange, 2147483647)));
      }
    }
  }

  customElements.define('customer-cashback-bar', CustomerCashbackBar);
})();
